import React from "react";
import { dateFilters } from "../../Dashboard/utils/dateFilters";

export default function TableDateFilter({
  dateFilter,
  setDateFilter,
  customStart,
  setCustomStart,
  customEnd,
  setCustomEnd,
  onFilterChange,
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 w-full">
      <select
        value={dateFilter}
        onChange={(e) => {
          setDateFilter(e.target.value);
          onFilterChange?.(e.target.value);
        }}
        className="border border-gray-300 rounded px-2 py-1 text-sm w-full"
      >
        {Object.keys(dateFilters).map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </select>

      {dateFilter === "Custom Range" && (
        <>
          <input
            type="date"
            value={customStart}
            onChange={(e) => {
              setCustomStart(e.target.value);
              onFilterChange?.("Custom Range");
            }}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
          />
          <span>–</span>
          <input
            type="date"
            value={customEnd}
            onChange={(e) => {
              setCustomEnd(e.target.value);
              onFilterChange?.("Custom Range");
            }}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
          />
        </>
      )}
    </div>
  );
}
